
document.addEventListener('DOMContentLoaded', () => {
    const mainSection = document.querySelector('.main-product-container')?.closest('.prada-mode-active');
    
    // 1. RECS ENGINE (Unwrap Swiper -> Native Scroll)
    function initPradaUnwrap() {
        const obs = new MutationObserver((mutations) => {
            const recs = document.querySelector('.product-info-wrapper product-recommendations');
            if (recs && !recs.classList.contains('prada-fixed')) {
                const wrapper = recs.querySelector('.swiper-wrapper');
                const originalCards = wrapper ? Array.from(wrapper.children) : recs.querySelectorAll('product-card-item, .grid__item, li');
                
                if (originalCards.length > 0) {
                    const validCards = Array.from(originalCards).filter(n => n.nodeType === 1 && n.tagName !== 'SCRIPT');
                    if (validCards.length > 0) {
                        recs.classList.add('prada-fixed'); 
                        const cleanContainer = document.createElement('div');
                        cleanContainer.className = 'prada-recs-container';
                        validCards.forEach(card => {
                            const cleanCard = card.cloneNode(true);
                            cleanCard.removeAttribute('style');
                            cleanCard.classList.remove('swiper-slide', 'swiper-slide-active');
                            cleanContainer.appendChild(cleanCard);
                        });
                        recs.innerHTML = ''; 
                        const header = document.createElement('h2');
                        header.innerText = 'Related Products';
                        header.className = 'prada-recs-title';
                        recs.appendChild(header);
                        recs.appendChild(cleanContainer);
                        recs.style.display = 'block';
                        recs.style.opacity = '1';
                    }
                }
            }
        });
        const target = document.querySelector('.product-info-wrapper');
        if (target) obs.observe(target, { childList: true, subtree: true });
    }
    
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPradaUnwrap);
    else initPradaUnwrap();
    if (!mainSection || window.innerWidth > 768) return; 
    // 2. DRAWER & GALLERY LOGIC
    const drawer = mainSection.querySelector('.product-info-wrapper');
    const gallery = mainSection.querySelector('.media-gallery-card');
    
    const setExpanded = (expanded) => {
        if (expanded) {
            drawer.classList.add('is-expanded');
            gallery?.classList.add('is-scaled'); 
            drawer.style.overflowY = 'auto';
            drawer.scrollTop = 1; // Wake up scroll
            document.body.style.overflow = 'hidden'; // Lock Body
        } else {
            drawer.classList.remove('is-expanded');
            gallery?.classList.remove('is-scaled'); 
            drawer.style.overflowY = 'hidden';
            drawer.scrollTop = 0; 
            document.body.style.overflow = '';
        }
    };
    // 3. INJECT PILLS & HANDLE
    if (drawer && !drawer.querySelector('.prada-drawer-handle')) {
        const handle = document.createElement('div');
        handle.classList.add('prada-drawer-handle');
        drawer.insertBefore(handle, drawer.firstChild);
        
        const arrowUp = `<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>`;
        
        // Pills
        const pillGallery = document.createElement('div');
        pillGallery.className = 'prada-guide-pill prada-pill-gallery';
        pillGallery.innerHTML = `${arrowUp} Swipe Up For Images`;
        handle.appendChild(pillGallery);
        
        const pillDrawer = document.createElement('div');
        pillDrawer.className = 'prada-guide-pill prada-pill-drawer';
        pillDrawer.innerHTML = `Pull Up For Details ${arrowUp}`;
        handle.appendChild(pillDrawer);
        
        setTimeout(() => {
            pillGallery.classList.add('visible');
            pillDrawer.classList.add('visible');
        }, 1000);
        
        const fadeOut = () => {
            if (!pillGallery.parentNode) return;
            pillGallery.classList.remove('visible');
            pillDrawer.classList.remove('visible');
            setTimeout(() => { pillGallery.remove(); pillDrawer.remove(); }, 800);
        };
        setTimeout(fadeOut, 6000);
        
        // Interactions
        drawer.addEventListener('touchstart', fadeOut, {once:true});
        gallery.addEventListener('touchstart', fadeOut, {once:true});
        
        // Drag Logic
        let startY = 0;
        let isDragging = false;
        let drawerStartY = 0;
        
        handle.addEventListener('touchstart', (e) => { startY = e.touches[0].clientY; isDragging = true; }, {passive:true});
        handle.addEventListener('touchend', (e) => {
             if (!isDragging) return; isDragging = false;
             if (drawer.classList.contains('is-expanded') && (e.changedTouches[0].clientY - startY) > 60) setExpanded(false);
        });
        handle.addEventListener('click', (e) => {
             if (Math.abs(e.clientY - startY) < 10) setExpanded(!drawer.classList.contains('is-expanded'));
        });
        
        // Swipe Up / Pull Down logic
        drawer.addEventListener('touchstart', (e) => {
            if (e.target.closest('product-recommendations') || e.target.closest('.prada-recs-container')) return;
            if (!drawer.classList.contains('is-expanded')) startY = e.touches[0].clientY;
            else drawerStartY = (drawer.scrollTop <= 0) ? e.touches[0].clientY : -1;
        }, {passive:true});
        
        // Block PTR
        drawer.addEventListener('touchmove', (e) => {
            if (drawer.classList.contains('is-expanded') && drawer.scrollTop <= 0 && e.touches[0].clientY > drawerStartY && drawerStartY > 0) {
                if (e.cancelable) e.preventDefault(); e.stopPropagation();
            }
        }, { passive: false });
        
        drawer.addEventListener('touchend', (e) => {
            if (e.target.closest('product-recommendations') || e.target.closest('.prada-recs-container')) return;
            if (!drawer.classList.contains('is-expanded') && (startY - e.changedTouches[0].clientY) > 40) setExpanded(true);
            else if (drawerStartY > 0 && drawer.scrollTop <= 0 && (e.changedTouches[0].clientY - drawerStartY) > 80) setExpanded(false);
        });
        // 8. GALLERY SWIPE UP (RESTORED)
        gallery.addEventListener('touchstart', (e) => {
            startY = e.touches[0].clientY; 
        }, {passive: true});
        
        gallery.addEventListener('touchend', (e) => {
             const endY = e.changedTouches[0].clientY;
             const max = gallery.scrollHeight - gallery.clientHeight;
             // If closed, at bottom, and swiped up
             if (!drawer.classList.contains('is-expanded') && 
                 (gallery.scrollTop >= max - 20) && 
                 (startY - endY > 50)) {
                 setExpanded(true);
             }
        });
    }
    // 4. COLORS
    const mobileScheme = Array.from(mainSection.classList).find(c => c.startsWith('color-mobile-'))?.replace('color-mobile-', '');
    if (mobileScheme) drawer.classList.add(`color-scheme-${mobileScheme}`);
    // 5. VERTICAL DOTS
    if (gallery && !mainSection.querySelector('.prada-mobile-pagination')) {
        const slides = gallery.querySelectorAll('.product-media-item, .swiper-slide');
        if (slides.length > 1) {
            const dotsContainer = document.createElement('div');
            dotsContainer.className = 'prada-mobile-pagination';
            slides.forEach((_, i) => {
                const dot = document.createElement('button');
                dot.className = `prada-pagination-dot ${i===0?'active':''}`;
                dotsContainer.appendChild(dot);
            });
            mainSection.appendChild(dotsContainer);
            
            const updateDots = () => {
                const index = Math.round(gallery.scrollTop / window.innerHeight);
                [...dotsContainer.children].forEach((dot, i) => dot.classList.toggle('active', i === index));
            };
            gallery.addEventListener('scroll', () => requestAnimationFrame(updateDots), {passive:true});
        }
    }
    // 6. GHOST CONTROLS V2 (With Glow)
    if (gallery && !mainSection.querySelector('.prada-ghost-controls')) {
        const style = document.createElement('style');
        style.innerHTML = `
            .prada-mode-active .product-single__media-zoom { display: none !important; }
            .prada-ghost-controls {
                position: fixed; right: 12px; top: 50%; transform: translateY(-50%); display: flex; flex-direction: column; gap: 16px;
                z-index: 15; opacity: 0; transition: opacity 0.5s ease; pointer-events: none;
            }
            .prada-ghost-controls.is-visible { opacity: 1; pointer-events: auto; }
            .prada-ghost-btn {
                width: 42px; height: 42px; border-radius: 50%;
                background: rgba(20, 20, 20, 0.6); backdrop-filter: blur(8px);
                border: 1px solid rgba(255, 255, 255, 0.15);
                box-shadow: 0 0 15px rgba(255, 255, 255, 0.15), 0 4px 12px rgba(0, 0, 0, 0.3); /* GLOW ADDED */
                display: flex; align-items: center; justify-content: center;
                color: rgba(255, 255, 255, 0.9); cursor: pointer; transition: all 0.2s ease;
            }
            .prada-ghost-btn:active { background: rgba(255, 255, 255, 0.2); transform: scale(0.92); }
            .prada-ghost-btn svg { width: 20px; height: 20px; stroke-width: 2; }
        `;
        document.head.appendChild(style);
        const controls = document.createElement('div');
        controls.className = 'prada-ghost-controls';
        controls.innerHTML = `
            <div class="prada-ghost-btn" id="ghost-up"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M18 15l-6-6-6 6"/></svg></div>
            <div class="prada-ghost-btn" id="ghost-zoom"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg></div>
            <div class="prada-ghost-btn" id="ghost-down"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg></div>
        `;
        mainSection.appendChild(controls);
        let ghostTimer;
        const wakeUpGhosts = () => {
            controls.classList.add('is-visible');
            clearTimeout(ghostTimer);
            ghostTimer = setTimeout(() => controls.classList.remove('is-visible'), 4000); 
        };
        ['scroll', 'touchstart', 'click'].forEach(evt => gallery.addEventListener(evt, wakeUpGhosts, {passive: true}));
        setTimeout(wakeUpGhosts, 500);
        controls.querySelector('#ghost-up').addEventListener('click', (e) => {
            e.stopPropagation();
            gallery.scrollBy({ top: -gallery.clientHeight, behavior: 'smooth' });
            wakeUpGhosts();
        });
        controls.querySelector('#ghost-down').addEventListener('click', (e) => {
             e.stopPropagation();
             const maxScroll = gallery.scrollHeight - gallery.clientHeight;
             if (Math.abs(gallery.scrollTop - maxScroll) < 20) setExpanded(true);
             else gallery.scrollBy({ top: gallery.clientHeight, behavior: 'smooth' });
             wakeUpGhosts();
        });
        controls.querySelector('#ghost-zoom').addEventListener('click', (e) => {
            e.stopPropagation(); wakeUpGhosts();
            const index = Math.round(gallery.scrollTop / gallery.clientHeight);
            const slide = gallery.querySelectorAll('.product-media-item, .swiper-slide')[index];
            if (slide) {
                const legacyBtn = slide.querySelector('.product-single__media-zoom');
                if (legacyBtn) legacyBtn.click(); else slide.querySelector('img')?.click();
            }
        });
    }
      // 7. JS ACCORDION SMOOTHING - REMOVED FOR PERFORMANCE (Using CSS Native)
      
});
